const SEARCH_FIELDS = ['asset_codigo_npl', 'asset_direccion', 'asset_municipio', 'asset_id_proveedor', 'asset_id_prestamo'];

export const matchesReviewAsset = (item, query) => {
  const needle = (query || '').trim().toLowerCase();
  return !needle || SEARCH_FIELDS.map(field => String(item[field] ?? '')).join(' ').toLowerCase().includes(needle);
};